document.addEventListener("DOMContentLoaded", function () {
  var dropdownSelected = document.querySelector(".url-dropdown-selected");
  var dropdownContent = document.querySelector(".url-dropdown-content");
  var dropdownItems = document.querySelectorAll(".url-dropdown-item:not(.url-dropdown-item--selected)");
  var dropdown = document.querySelector(".url-dropdown");

  dropdownSelected.addEventListener("click", function () {
    var expanded = dropdown.getAttribute("aria-expanded") === "true" || false;
    dropdown.setAttribute("aria-expanded", !expanded);
    dropdownContent.style.display = !expanded ? "block" : "none";
  });

  dropdownItems.forEach(function (item) {
    item.addEventListener("click", function () {
      var url = item.dataset.value;
      window.location.href = url;
    });

    item.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        item.click();
      }
    });
  });

  // Close the dropdown if clicked outside
  document.addEventListener("click", function (event) {
    if (
      !dropdownSelected.contains(event.target) &&
      !dropdownContent.contains(event.target)
    ) {
      dropdownContent.style.display = "none";
      dropdown.setAttribute("aria-expanded", "false");
    }
  });

  dropdownSelected.addEventListener("keydown", function (event) {
    if (event.key === "Enter" || event.key === " ") {
      dropdownSelected.click();
    }
  });
});
